import { defineStore } from 'pinia';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';

export const useContentFeedStore = defineStore('content-feed', {
    state,
    getters,
    actions,
});
